import { NgModule } from '@angular/core';
import { NotificationsRoutingModule } from './notifications-routing.module';
import { MarkAsReadNotificationsCommandHandler, NotificationsListQueryHandler } from './application/handlers';
import {
  CustomNotificationService,
  NotificationsAlertsService,
  NotificationsPreferencesService
} from '@notifications/infra';

@NgModule({
  imports: [NotificationsRoutingModule],
  providers: [
    NotificationsListQueryHandler,
    MarkAsReadNotificationsCommandHandler,
    NotificationsAlertsService,
    CustomNotificationService,
    NotificationsPreferencesService
  ]
})
export class NotificationsModule {}
